<template>
  <page-outline :title="titleLabel" :icon="titleIcon" noReturn
    pageClass="rtp_details">
    <template slot="pageContent">
      <spinner v-if="!details.id || activateSpinner"></spinner>
      <div class="ml-3 mr-3" v-else>
        <b-row align-h="start">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button></back-button>
          </b-col>
          <b-col cols="4" sm="3" md="2" xl="1"  @click="seeDetails">
            <b-button class="back-button">
              <i class="fa-solid fa-rotate-right fs-14px"></i>
            </b-button>
          </b-col>
        </b-row>
        <br/>
        <form-accordion :title="$t('attachments.doc_sent_list')" :isTitleUpperCase="false" v-if="details.Attachments && details.Attachments.length">
          <document-list :documents="details.Attachments"></document-list>
        </form-accordion>
        <form-accordion :title="$t('common.rqst_fr_gr')" :isTitleUpperCase="false"
          v-if="showOtherDebtors() && otherRTP.length > 1">
          <transactions-list
            filterBy="" itemListStyle="border-radius:0;"
            :actualMessageId="details.id"
            :messages="otherRTP"
            :randomId="randomId"
            :serviceId="services.PAYMENTS">
          </transactions-list>
        </form-accordion>

        <hr v-if="showOtherDebtors() && otherRTP.length > 1" class="mx-auto" />
        <form-accordion :title="$t('common.request_details')" :isTitleUpperCase="false">
          <b-row v-if="details.endToEndId || details.uri">
            <b-col xl="3" cols="3" class="form-group">
              <form-read-group-label-input v-if="details.endToEndId"
                :inputLabel="$t('common.invc_ref')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="details.endToEndId"
                labelClass="mb-0"
                class="">
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-if="details.uri && details.uri.startsWith('REQ/ ')">
              <form-read-group-label-input
                :inputLabel="$t('common.uri')"
                :colLabelSize="4"
                :colInputSize="8"
                inputId="inputUri"
                :inputValue="details.uri.substring(5, details.uri.length)"
                labelClass="mb-0"
                class="">
                <div slot="afterInput" class="tooltip-info">
                  <i class="fa-duotone fa-file-text cursor text-info fs-20px ml-5px"
                    @click="copyToClipboard(details.uri.substring(5, details.uri.length))"
                    @mouseout="copyToClipboardReset()">
                    <span id="copyUri" class="tooltiptext">{{ $t('common.copy_to_clipboard') }}</span>
                  </i>
                </div>
              </form-read-group-label-input>
            </b-col>
            <b-col v-else xl="3" cols="3"></b-col>
            <b-col xl="3" cols="3" class="form-group">
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" cols="3" class="form-group" v-if="showAcceptModifyReasonValidated()">
              <form-read-group-label-input :inputLabel="$t('common.rsn')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="details.acceptedRemittanceInformation ? details.acceptedRemittanceInformation : details.reason"
                labelClass="mb-0"
                :tooltipLabel="concatenatedDateReasonText($t('common.rsn_ask'))">
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyReasonCreditor()">
              <form-read-group-label-input :inputLabel="$t('common.rsn')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="details.acceptedRemittanceInformation ? details.acceptedRemittanceInformation : details.reason"
                labelClass="mb-0"
                :tooltipLabel="$t('requestToPay.modify_reason_debtor')">
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-else>
              <form-read-group-label-input :inputLabel="$t('common.rsn')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="details.acceptedRemittanceInformation ? details.acceptedRemittanceInformation : details.reason"
                labelClass="mb-0">
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-if="showAcceptModifyAmountValided()">
              <form-read-group-label-input :inputLabel="$t('common.amnt_ttl_accept')"
                :inputValue="details.acceptedAmount + ' ' + getCurrencyIcon(details.currency)"
                :colLabelSize="4"
                :colInputSize="8"
                labelClass="mb-0"
                :tooltipLabel="concatenatedDateAmountText($t('common.amnt_ttl_ask'))">
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyAmountCreditor()">
              <b-row class="align-items-end">
                <b-col cols="11">
                  <form-read-group-label-input :inputLabel="$t('common.amnt_ttl')"
                    :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)"
                    :colLabelSize="4"
                    :colInputSize="8"
                    labelClass="mb-0"
                    :tooltipLabel="$t('requestToPay.modify_amount_debtor')">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-else>
              <form-read-group-label-input :inputLabel="details.installments.length ? $t('common.amnt_ttl') : (details.creditNoteAmount ? $t('common.amnt_crdt_nt') : $t('common.amnt_ttl'))"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="(details.creditNoteAmount ? details.creditNoteAmount : details.amount) + ' ' + getCurrencyIcon(details.currency)"
                labelClass="mb-0"
                class="">
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group">
              <form-read-group-label-input :inputLabel="$t('common.status.status_label')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="getStatusLabel(details.status, details.negotStatus)"
                labelClass="mb-0"
                class=""
                :tooltipLabel="getStatusReason(details.status)">
              </form-read-group-label-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" cols="3" class="form-group">
              <form-read-group-label-input :inputLabel="$t('common.rqst_date')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="details.dateTime | formatDateTime"
                labelClass="mb-0">
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-if="!isHRTP">
              <form-read-group-label-input :inputLabel="$t('common.date_expr')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="details.requestedExpirationDate | formatDateTime"
                labelClass="mb-0">
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-if="showAcceptModifyDate() && !details.installments.length">
              <form-write-group-label-input :inputLabel="$t('common.exec_date')"
                inputIcon="fa-solid fa-calendar text-info"
                v-model="requestedExecutionDateFormat"
                :colLabelSize="4"
                :colInputSize="8"
                inputType="datetime" disablePastDates
                labelClass="mb-0"
                :tooltipLabel="$t('requestToPay.modify_date_creditor')">
                <i slot="afterInput"
                  v-if="hasPastExecutionDate && !details.installments.length"
                  class="fa-duotone fa-warning cursor text-warning fs-20px ml-5px"
                  :title="$t('common.exec_date_exprd')">
                </i>
              </form-write-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyDateValided() && !details.installments.length">
              <form-read-group-label-input :inputLabel="$t('common.exec_date_accept')"
                inputIcon="fa-solid fa-calendar text-info"
                :inputValue="details.acceptedRequestedExecutionDatetime | formatDateTime"
                :colLabelSize="4"
                :colInputSize="8"
                inputType="date" disablePastDates
                labelClass="mb-0"
                :tooltipLabel="concatenatedDateAskText($t('common.exec_date_ask'))">
                <i slot="afterInput"
                  v-if="hasPastExecutionDate && !details.installments.length"
                  class="fa-duotone fa-warning cursor text-warning fs-17px ml-5px"
                  :title="$t('common.exec_date_exprd')">
                </i>
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyDateCreditor() && !details.installments.length">
              <form-read-group-label-input :inputLabel="$t('common.exec_date')"
                inputIcon="fa-solid fa-calendar text-info"
                :inputValue="details.requestedExecutionDate | formatDateTime"
                :colLabelSize="4"
                :colInputSize="8"
                inputType="date" disablePastDates
                labelClass="mb-0"
                :tooltipLabel="$t('requestToPay.modify_date_debtor')">
                <i slot="afterInput"
                  v-if="hasPastExecutionDate && !details.installments.length"
                  class="fa-duotone fa-warning cursor text-warning fs-17px ml-5px"
                  :title="$t('common.exec_date_exprd')">
                </i>
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group" v-else-if="!details.installments.length">
              <form-read-group-label-input :inputLabel="$t('common.exec_date')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="details.requestedExecutionDate | formatDateTime"
                labelClass="mb-0">
                <i slot="afterInput"
                  v-if="hasPastExecutionDate && !details.installments.length"
                  class="fa-duotone fa-warning cursor text-warning fs-17px ml-5px"
                  :title="$t('common.exec_date_exprd')">
                </i>
              </form-read-group-label-input>
            </b-col>
            <b-col cols="3" class="form-group" v-else>
            </b-col>
            <b-col cols="3" class="form-group" v-if="isHRTP">
            </b-col>
          </b-row>
          <b-row v-if="details.paymentRequest">
            <b-col cols="3" class="form-group" v-if="details.paymentRequest.debtorIban">
              <form-read-group-label-input :inputLabel="$t('common.debtor_ibn_used')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="details.paymentRequest.debtorIban"
                labelClass="mb-0"
                class="">
              </form-read-group-label-input>
            </b-col>
            <b-col cols="3" class="form-group" v-if="details.paymentRequest.status">
              <form-read-group-label-input :inputLabel="$t('common.payment_status')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="$t('common.status.payment.' + details.paymentRequest.status)"
                labelClass="mb-0"
                class="">
              </form-read-group-label-input>
            </b-col>
            <b-col cols="3" v-if="canSeePain001 && details.paymentRequest.format && details.paymentRequest.format.out.id">
              <form-read-group-label-input :inputLabel="$t('common.flux_out')"
                :colLabelSize="4"
                :colInputSize="8"
                :inputValue="details.paymentRequest.format.out.type"
                labelClass="mb-0"
                class="">
              </form-read-group-label-input>
              <i class="fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue" @click="seeXml(details.paymentRequest.format.out, 'payment', 'see')"></i>
              <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(details.paymentRequest.format.out, 'payment', 'download')"></i>
            </b-col>
          </b-row>
        </form-accordion>
        <!-- INSTALLMENTS -->
        <form-accordion v-if="details.installments.length" :title="$t('common.request_installments_proposed')" :isTitleUpperCase="false" :key="installmentRefresh">
          <b-row v-for="(installment, installmentIndex) in details.installments" :key="installmentIndex">
            <b-col cols="12">
              <b-row class="justify-content-start" >
                <b-col cols="2" class="form-group" v-if="showAcceptModifyAmount()">
                  <form-write-group-label-input :inputLabel="$t('common.amnt_installment_rtp')"
                    inputType="number"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :minValue="0"
                    v-model="details.installments[installmentIndex].Amount"
                    labelClass="mb-0"
                    class=""
                    :tooltipLabel="$t('requestToPay.modify_amount_creditor')"
                    @blur="changeDebtorsAmount"
                    >
                  </form-write-group-label-input>
                </b-col>
                <b-col cols="2" class="form-group" v-else>
                  <form-read-group-label-input :inputLabel="$t('common.amnt_installment_rtp')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="details.installments[installmentIndex].Amount + ' ' + getCurrencyIcon(details.installments[installmentIndex].Currency)"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col cols="2" class="form-group" v-if="showAcceptModifyDate()">
                  <form-write-group-label-input :inputLabel="$t('common.execution_date_label')"
                    inputIcon="fa-solid fa-calendar text-info"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :value="formateInstalmentDate(details.installments[installmentIndex].Date)"
                    @input="changeInstallementDates($event, installmentIndex)"
                    inputType="datetime" disablePastDates
                    labelClass="mb-0"
                    :tooltipLabel="$t('requestToPay.modify_date_creditor')"
                    @blur="changeDebtorsDate"
                    >
                  </form-write-group-label-input>
                </b-col>
                <b-col cols="3" class="form-group" v-else>
                  <form-read-group-label-input :inputLabel="$t('common.execution_date_label')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="details.installments[installmentIndex].Date | formatDateTime"
                    labelClass="mb-0">
                  </form-read-group-label-input>
                </b-col>
                <b-col cols="3" class="form-group" v-if="installment.paymentRequest && installment.paymentRequest.debtorIban">
                  <form-read-group-label-input :inputLabel="$t('common.debtor_ibn_used')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="installment.paymentRequest.debtorIban"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col cols="1" class="form-group" v-if="installment.paymentRequest && installment.paymentRequest.status">
                  <form-read-group-label-input :inputLabel="'Statut'"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="$t('common.status.payment.' + installment.paymentRequest.status)"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col cols="3" v-if="installment.paymentRequest && installment.paymentRequest.format && installment.paymentRequest.format.out.id">
                  <label>{{ 'Flux Sortant' }}</label>
                  <div>
                    <span>{{ installment.paymentRequest.format.out.type }}</span>
                    <i class="fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue" @click="seeXml(installment.paymentRequest.format.out, 'payment', 'see')"></i>
                    <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(installment.paymentRequest.format.out, 'payment', 'download')"></i>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="hasPastExecutionDateInstalment(installment)">
                <b-col xl="3" cols="3" offset="1" class="form-group text-right text-warning font-weight-bold">
                  <small><i class="fa-duotone fa-warning cursor"></i> {{ $t('common.exec_date_exprd') }}</small>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </form-accordion>

        <hr class="mx-auto" />

        <!-- CREDITOR INFORMATIONS -->
        <form-accordion :title="$t('creation_forms.crdtr_info')" :isTitleUpperCase="false">
          <b-row class="pt-1 mb-3">
            <template>
              <b-col xl="3" cols="3" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.my_nme')"
                  :inputValue="details.creditorName"
                  labelClass="mb-0">
                </form-read-group-label-input>
              </b-col>
            </template>
            <b-col xl="3" cols="3" class="form-group">
              <form-read-group-label-input :inputLabel="$t('common.rtp_dbtr_ibn')"
                :inputValue="details.creditorBankAccount"
                labelClass="mb-0"
                class="">
              </form-read-group-label-input>
            </b-col>
            <b-col xl="3" cols="3" class="form-group">
              <form-read-group-label-input
                :inputLabel="$t('common.my_provider')"
                :inputValue="details.creditorBIC"
                labelClass="mb-0">
              </form-read-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>

          <hr class="mx-auto" />

          <!-- DEBTOR INFORMATIONS -->
          <form-accordion :title="$t('creation_forms.dbtr_info')" :isTitleUpperCase="false">
            <b-row class="pt-1 mb-3">
              <b-col xl="3" cols="3" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.my_nme')"
                  :inputValue="details.debtorName"
                  labelClass="mb-0"
                  class="">
                </form-read-group-label-input>
              </b-col>
              <b-col xl="3" cols="3" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.rtp_dbtr_ibn')"
                  :inputValue="details.debtorBankAccount ? details.debtorBankAccount : '-'"
                  labelClass="mb-0"
                  class="">
                </form-read-group-label-input>
              </b-col>
              <b-col xl="3" cols="3" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.rtp_dbtr_provider')"
                  :inputValue="details.debtorIdProvider"
                  labelClass="mb-0"
                  class="">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>

          <b-row class="panel-subtitle d-none" v-if="details.direction === '0'">
            <b-col class="form-group">
              <b-form-checkbox v-model="details.instantPayment"
                v-if="showInstantPayment(details.debtorBankAccount)"
                class="mt-sm-2" value="1" unchecked-value="0"
                :disabled="!waitingForAnswerRTP(details.status) || isInstantPayment">
                {{ $t('requestToPay.is_inst_payment') }}
                {{ '(' + getBankName(details.debtorBankAccount) + ')' }}
              </b-form-checkbox>
            </b-col>
          </b-row>

          <div v-if="(waitingForAnswerRTP(details.status) && details.negotStatus === '10') ||
            (waitingForAnswerRTP(details.status) && details.negotStatus === '11') ||
            details.status === status.ACCEPTED ||
            details.status === status.MODIFIED ||
            details.status === status.REVOKED ||
            details.status === status.ACCEPTED_AND_PAYED ||
            details.status === status.ACCEPTED_AND_PAYED_INST ||
            details.status === status.MODIFIED_AND_PAYED ||
            details.status === status.MODIFIED_AND_PAYED_INST ||
            details.status === status.ORDER_GENERATED ||
            details.status === status.MADE ||
            details.status === status.INST_MADE">
            <!-- TLV 13/09/2020 Affichage de l'historique du montant et de la date d'exécution, s'il a lieu d'être -->
            <div v-if="((details.amountResponse.length > 0 && details.amountResponse !== details.amount) ||
              (details.executionDateResponse.length > 0 && details.requestedExecutionDate !== details.executionDateResponse))">
              <b-row class="form-group">
                <b-col class="transactionDetailSubHeader">
                  {{ $t('common.orig_terms') }}
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6" class="form-group"
                  v-if="details.amountResponse.length > 0 && details.amountResponse !== details.amount">
                  <form-read-group-label-input :inputLabel="$t('common.orig_amount')" horizontal
                    :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)"
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group"
                  v-if="details.executionDateResponse.length > 0 && details.requestedExecutionDate !== details.executionDateResponse">
                  <form-read-group-label-input :inputLabel="$t('common.exec_date_orig')" horizontal
                    :inputValue="details.requestedExecutionDate | formatDate"
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </div>
          </div>

          <!-- ============================== -->
          <!--          INSTALLMENTS          -->
          <!-- ============================== -->
          <b-col sm="6" class="form-group pl-sm-0"
            v-if="details.hasPmtResp === '1' && details.pmtResp.multPmts.length > 0">
            <label class="text-decoration-underline-hover mb-0">
              {{ $t('common.pymnts_annoucement', {install_number: details.pmtResp.multPmts.length}) }}
            </label>
            <table class="table">
              <thead>
                <tr>
                  <th>{{ $t('common.installment_amount') }}</th>
                  <th>{{ $t('common.installment_date') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(installment, index) in details.pmtResp.multPmts" :key="'installment-' + index">
                  <td>
                    {{ installment.amount + ' ' + getCurrencyIcon(installment.currency) }}
                  </td>
                  <td>{{ installment.date | formatDate }}</td>
                  <td>
                    <span>
                      <f7-icon icon="icon-clock_forward"
                        v-if="installment.pay === '0' || installment.pay === '1'"
                        class="icon-transaction-detail">
                      </f7-icon>
                      <!-- <f7-icon icon="icon-money"
                        v-else-if="installment.pay === '1'"
                        class="icon-transaction-detail">
                      </f7-icon> -->
                      <f7-icon icon="icon-receipt"
                        v-else-if="installment.pay === '2'"
                        class="icon-transaction-detail">
                      </f7-icon>
                      <f7-icon icon="icon-made" v-else
                        class="icon-transaction-detail">
                      </f7-icon>
                      </i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>

          <b-row class="mt-2" v-if="false && (details.Attachments && details.Attachments.length > 0) || details.lettrage">
            <b-col sm="6" class="form-group" v-if="details.lettrage">
              <b-row>
                <b-col cols="12" class="transactionDetailSubHeader">
                  {{ "Lettrage" }}
                </b-col>
                <b-col cols="12" class="mt-2">
                  {{ details.lettrage && details.lettrage.length > 0 ? formatLettrage(details.lettrage) : 'Pas de lettrage' }}
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="6" class="form-group" v-if="details.Attachments && details.Attachments.length > 0">
              <b-row>
                <b-col cols="12" class="transactionDetailSubHeader">
                  {{ "Document" }}
                </b-col>
              </b-row>
              <document-list :documents="details.Attachments"></document-list>
              <!--<b-row v-for="attachment in details.Attachments" :key="attachment.AttachmentId">
                <b-col sm="12" class="form-group">
                  <div class="d-flex justify-content-start">
                    <label id="application-file-input">
                      {{ attachment.AttachmentName }}
                    </label>
                    <div class="d-flex ml-3">
                      <i class="fa fa-eye cursor" @click="seeXml(details.paymentRequest.format.out, 'payment', 'see')" style="color: var(--actionButtonColorBlue)"></i></i>
                      <i class="fa fa-download cursor" @click="seeXml(details.paymentRequest.format.out, 'payment', 'download')" style="color: var(--actionButtonColorBlue)"></i></i>
                    </div>
                  </div>
                </b-col>
              </b-row>-->
            </b-col>
          </b-row>

          <div v-if="showNegotiation()">
            <b-row class="form-group">
              <b-col class="transactionDetailSubHeader">
                Negotiation
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.new_amount')" horizontal
                  :inputValue="details.pmtNegot.amountDebtor + ' ' + getCurrencyIcon(details.ccy)">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group"
                v-if="details.pmtNegot.multiPayments.length > 0">
                <label class="text-decoration-underline-hover">
                  {{ $t('common.pymnts_annoucement', {install_number:
                  details.pmtNegot.multiPayments.length}) }}
                </label>
                <table class="table">
                  <thead>
                    <tr>
                      <th>{{ $t('common.installment_amount') }}</th>
                      <th>{{ $t('common.installment_date') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(pmt, index) in details.pmtNegot.multiPayments" :key="'pmt-' + index">
                      <td>
                        {{ pmt.amount + ' ' + getCurrencyIcon(details.currency) }}
                      </td>
                      <td>
                        {{ pmt.date | formatDate }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

          </div>
          <div v-if="(details.negotStatus === '12')">
            <b-row class="form-group">
              <b-col class="transactionDetailSubHeader">
                Final Terms
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.final_amount')" horizontal
                  :inputValue="details.pmtResp.dbtAmt !== ''
                  ? (details.pmtResp.dbtAmt + getCurrencyIcon(details.currency))
                  : (details.amount + getCurrencyIcon(details.currency))">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group"
                v-if="details.pmtResp.multPmts.length > 0">
                <label class="text-decoration-underline-hover">
                  {{ $t('common.pymnts_annoucement', {install_number:
                  details.pmtResp.multPmts.length}) }}
                </label>
                <table class="table">
                  <thead>
                    <tr>
                      <th>{{ $t('common.installment_amount') }}</th>
                      <th>{{ $t('common.installment_date') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(pmt, index) in details.pmtResp.multPmts" :key="'pmt-' + index">
                      <td>
                        {{ pmt.amount + ' ' + getCurrencyIcon(details.currency) }}
                      </td>
                      <td>
                        {{ pmt.date | formatDate }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </div>

        <hr v-if="details.status === status.REVOKED" class="mx-auto"/>

        <form-accordion :title="$t('common.formsSubTitle.refuse_reason')" font-size="1rem"
          v-if="details.status === status.REVOKED">
          <b-row>
            <b-col>
              <p>{{ details.decisionMessage }}</p>
            </b-col>
          </b-row>
        </form-accordion>

        <hr v-if="details.cancelMessage && details.cancelMessage !== ''" class="mx-auto"/>

        <form-accordion :title="$t('common.formsSubTitle.cancel_reason')" font-size="1rem"
          v-if="details.cancelCode && details.cancelCode !== ''">
          <b-row>
            <b-col>
              <p><b>{{ $t(getCancelCodeLabel(details.cancelCode)) }}</b></p>
              <p v-if="details.cancelMessage && details.cancelMessage !== ''">{{ details.cancelMessage }}</p>
            </b-col>
          </b-row>
        </form-accordion>

        <hr v-if="details.direction === '0' && waitingForAnswerRTP(details.status) && details.acceptMultipleInstalments === '1'" class="mx-auto" />

        <form-accordion :title="'ECHEANCIER'" font-size="1rem"
          v-if="details.direction === '0' && waitingForAnswerRTP(details.status) && details.acceptMultipleInstalments === '1'">
          <b-row>
            <b-col>
              <b-form-checkbox v-model="showInstallments"
                class="mt-sm-2"
                :value="true" :unchecked-value="false">
                {{ $t('common.ask_multiple_payments_times') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
          <br/>
          <b-row v-if="showInstallments">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="numInstallments"
                inputType="number"
                inputLabel="Nombre d'échéances">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row v-if="showInstallments">
            <b-col>
              <echeancier v-model="multPmts"
                :numPay="numInstallments" :min="1"
                :amount="details.amount" ccy="€" :deposit="0"
                :execDate="details.requestedExecutionDate">
              </echeancier>
            </b-col>
          </b-row>
        </form-accordion>

        <hr class="mx-auto" />

        <form-accordion :title="$t('common.formsSubTitle.rqst_to_pay_hstry')" :open="true" :isTitleUpperCase="false">
          <b-row class="form-group">
            <b-col>
              <table class="table text-center">
                <thead>
                  <tr>
                    <th>
                      {{ $t('common.date_request_label') }}
                    </th>
                    <th>
                      {{ $t('common.status.status_label') }}
                    </th>
                    <th v-if="fileFormat && hasRight('xmlDetail_consulter')">
                      {{ $t('requestToPay.stream_in')}}
                    </th>
                    <th v-if="fileFormat && hasRight('xmlDetail_consulter')">
                      {{ $t('requestToPay.stream_out')}}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="record in details.history" :key="record.id">
                    <td>
                      {{ record.creationDate | formatDateTime }}
                    </td>
                    <td>
                      {{getHistoryLabel(record.status)}}
                    </td>
                    <td v-if="fileFormat && hasRight('xmlDetail_consulter')">
                      <div v-if="!record.format.in.id || record.format.in.id === '0'">-</div>
                      <div v-else class="d-xl-flex align-items-center justify-content-center">
                        {{record.format.in.type}}
                        <div>
                          <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.in, 'requestToPay', 'see')"></i>
                          <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.in, 'requestToPay', 'download')"></i>
                        </div>
                      </div>
                    </td>
                    <td v-if="fileFormat && hasRight('xmlDetail_consulter')">
                      <div v-if="!record.format.out.id || record.format.out.id === '0'">-</div>
                      <div v-else class="d-xl-flex align-items-center justify-content-center">
                        {{record.format.out.type}}
                        <div>
                          <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'requestToPay', 'see')"></i>
                          <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'requestToPay', 'download')"></i>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </form-accordion>
      </div>
    </template>
  </page-outline>
</template>

<script>
import b64toBlob from 'b64-to-blob'
// import base64url from 'base64url'
import moment from 'moment'
import _ from 'lodash'

import backButton from '@/components/common/backButton.vue'
import documentList from '@/components/common/documentList.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import spinner from '@/components/common/spinner.vue'

import bankDatas from '@/pages/requests/components/data/bankDatas.json'
import Echeancier from '@/pages/requests/EcheancierForm.vue'
import selectBankAccount from '@/pages/requests/components/selectBankAccount.vue'
import TransactionsList from '@/pages/requests/TransactionsList.vue'

import { errorMessageAlert } from '@/helpers/alert'
import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import { formatDateTime, formatIbanHiddenEnd, formatLettrage } from '@/helpers/format'
import { loadPage } from '@/helpers/routing'
import services from '@/helpers/services'
import { statusLabel, statusIcon, getCancelLabel } from '@/helpers/labels'
import status from '@/helpers/status'

export default {
  name: 'transaction-details',
  components: {
    echeancier: Echeancier,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    spinner: spinner,
    'transactions-list': TransactionsList,
    'back-button': backButton,
    'document-list': documentList,
    'select-bank-account': selectBankAccount
  },
  data () {
    return {
      acceptInstallments: true,
      action: '',
      activateSpinner: false,
      attachement: '',
      attachementId: '',
      attachementName: '',
      attachementReference: '',
      amountBeforeModify: '',
      bankAccountSelectDebit: '',
      debtorBankAccount: '',
      details: {},
      fileFormat: [],
      hasInstallmentsChanged: false,
      ImmPmtAccepted: '',
      idRequest: '',
      idRefresh: undefined,
      installmentRefresh: false,
      label: '',
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig,
      multPmts: [],
      nbRefresh: 0,
      numInstallments: '1',
      originalAmount: '',
      originalDate: '',
      originalInstallements: '',
      originalReason: '',
      oldAmountGet: '',
      oldDateGet: '',
      oneTimePayment: undefined,
      otherRTP: [],
      paymentInstalmentModeChoosed: false,
      paymentMethod: '',
      payStatus: '0',
      randomId: Math.random().toString(36).substr(2, 10),
      refreshTimers: [5, 10, 15, 30, 60], // temps en secondes de chaque refresh auto
      services: services,
      showIbanBox: false,
      showInstallments: false,
      showReason: false,
      standard: '1',
      status: status,
      today: moment().format()
    }
  },
  created () {
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    // this.$bus.emit('service:change', 'Payments')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    if (this.details.id) {
      this.oldAmountGet = this.details.amount
      this.oldDateGet = this.details.requestedExecutionDate
    }
    if (this.details.dbBkAcct !== '') {
      this.bankAccountSelectDebit = this.details.debtorBankAccount
    } else {
      if (
        this.$engine.bankAccounts.getDefaultBankAccount().iban !== undefined
      ) {
        this.bankAccountSelectDebit =
          this.$engine.bankAccounts.getDefaultBankAccount().iban
      } else {
        this.bankAccountSelectDebit = ''
      }
    }
    this.paymentMethod = this.$engine.settings.get(1).paymentMethod

    this.$bus.$on('pay-transaction', (data) => {
      this.debtorBankAccount = data.bankAccount
      if (this.payStatus === '1') {
        this.transactionAcceptedAndPay()
      } else {
        this.pay()
      }
    })

    let that = this
    this.$bus.$on('answer-to-payments', (data) => {
      that.acceptInstallments = data.acceptInstallments
      that.oneTimePayment = data.oneTimePayment
      that.paymentInstalmentModeChoosed = true
      that.answerToPayments(data.status, data.optionals)
    })

    this.$bus.$on('cancel-payment', (data) => {
      that.cancelRequestToPay(data.endToEndId, data.reason, data.reasonType)
    })

    this.seeDetails()

    /* Récupération des autres paiements */
    if (this.showOtherDebtors()) {
      let filterConditions = {
        IdGroup: this.details.IdGroup,
      }
      this.$engine.services.payments
        .update(2, 100, 1, filterConditions)
        .then((resp) => {
          this.otherRTP = resp.data.payments
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    }
    // this.details.direction = '0'
  },
  mounted () {},
  beforeDestroy () {
    // this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
    this.attachementName = ''
    this.attachment = ''
    this.attachementReference = ''
    this.$bus.$off('pay-transaction')
    this.$bus.$off('answer-to-payments')
    this.$bus.$off('cancel-payment')
  },
  computed: {
    bankAccounts () {
      return this.$engine.bankAccounts.get()
    },
    canCancelRTP () {
      this.$engine.rights.rightIs('paymentCancel_ajouter', true)
    },
    canSeePain001 () {
      return false
    },
    getCancelReason () {
      // reason et reasonType
      // console.log('reason', this.details.cancelReason)
      // console.log('reasonType', this.details.cancelReasonType)
      if (this.details.cancelReasonType === 'Proprietary') {
        return this.details.cancelReason
      } else {
        return this.$i18n.t('common.cancel_reason.' + this.details.cancelReason)
      }
    },
    getRefusReason () {
      // cancelReason et cancelReasonType
      if (this.details.rejectReasonType === 'Proprietary') {
          return this.details.rejectReason
      } else {
        return this.$i18n.t('common.reject_reason.' + this.details.rejectReason)
      }
    },
    hasPastExecutionDate () {
      return ['9','10'].includes(this.details.status) && this.details.direction === '0'
        && (this.details.acceptedRequestedExecutionDatetime
          ? moment(this.details.acceptedRequestedExecutionDatetime) < moment()
          : moment(this.details.requestedExecutionDate) < moment())
    },
    installementExecutionDates: {
      get () {
        return moment(this.details.installments[0].Date).format('YYYY-MM-DDTHH:mm')
      },
      set (value) {
        this.details.installments[0].Date = value.format('YYYY-MM-DDTHH:mm:ss')
        this.details.installments[1].Date = this.details.installments[1].Date
      },
      get () {
        return moment(this.details.installments[1].Date).format('YYYY-MM-DDTHH:mm')
      },
      set (value) {
        this.details.installments[0].Date = this.details.installments[0].Date
        this.details.installments[1].Date = value.format('YYYY-MM-DDTHH:mm:ss')
      },

    },
    isDebtorAnon () {
      return (
        this.details.debtorName === undefined || this.details.debtorName === ''
      )
    },
    isDebtorBankAccountAvailable () {
      return ['5', '9','10','11','12','120','121','20'].includes(this.details.status)
    },
    isDebtorBankAccountEditable () {
      return ['5','9','10'].includes(this.details.status)
    },
    isHRTP () {
      return this.standard === '2'
    },
    isInstantPayment () {
      let today = moment().format('YYYY-MM-DD')
      if (this.details.executionDateResponse.length > 0) {
        return (
          moment(this.details.executionDateResponse).format('YYYY-MM-DD') ===
          today
        )
      } else {
        return (
          moment(this.details.requestedExecutionDate).format('YYYY-MM-DD') ===
          today
        )
      }
    },
    isUserDebtor () {
      return this.details.debtorIdProvider === this.$engine.settings.getGlobal().RTPSPIdentifier && this.details.debtorIdCompany === this.$engine.settings.get().clientIdentifier
    },
    oldAmount () {
      if (this.oldAmountGet === '' && this.details.amount) {
        this.oldAmountGet = this.details.amount
      }
      return this.oldAmountGet
    },
    oldDate () {
      if (this.oldDateGet === '' && this.details.requestedExecutionDate) {
        this.oldDateGet = this.details.requestedExecutionDate
      }
      return this.oldDateGet
    },
    requestedExecutionDateFormat: {
      get () {
        return moment(this.details.requestedExecutionDate).format('YYYY-MM-DDTHH:mm')
      },
      set (value) {
        this.details.requestedExecutionDate = formatDateTime(value)
      }
    },
    titleIcon () {
      if (this.details.direction === '0') {
        return 'icon-inbox'
      } else {
        return 'icon-sent'
      }
    },
    titleLabel () {
      return this.$t('requestToPay.rtp_details')
    },
    userIdentifier () {
      return this.$engine.user.get().identifier
    }
  },
  methods: {
    acceptNegotiation () {
      let that = this
      if (
        parseFloat(this.$engine.settings.get(1).validationThreshold) >
        parseFloat(this.details.amount)
      ) {
        that.$engine.services.payments
          .negotiatePayments(
            that.$settings.clickedMessage.id,
            'negotResp',
            'OK',
            Number(that.details.pmtNegot.amountDebtor),
            false,
            that.details.pmtNegot.debtorPaymentsDate,
            '',
            that.details.pmtNegot.multiPayments
          )
          .then((response) => {
            if (response.status === 200) {
              that.$f7.alert('', 'Negotiation Accepted', function () {
                that.$f7.closeModal()
                that.seeDetails()
              })
            }
          })
          .catch((error) => {
            errorMessageAlert(error, that)
          })
      } else {
        that.$f7.modal({
          title: 'Confirm Negotiation',
          text: 'Comment (optional, 255 chars maximum)',
          afterText:
            '<div class="item-input textarea-modal-rtp"><textarea class="acceptNegotiation commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {},
            },
            {
              text: 'Ok',
              onClick: function () {
                that.$engine.services.payments
                  .negotiatePayments(
                    that.$settings.clickedMessage.id,
                    'negotResp',
                    'OK',
                    Number(that.details.pmtNegot.amountDebtor),
                    false,
                    that.details.pmtNegot.debtorPaymentsDate,
                    that.Dom7('.acceptNegotiation').val(),
                    that.details.pmtNegot.multiPayments
                  )
                  .then((response) => {
                    if (response.status === 200) {
                      that.$f7.alert('', 'Negotiation Accepted', function () {
                        that.$f7.closeModal()
                        that.seeDetails()
                      })
                    }
                  })
                  .catch((error) => {
                    errorMessageAlert(error, that)
                  })
              }
            }
          ]
        })
      }
    },
    answerToPayments (status, optionals = { ImmPmtAc: 'false', reasonType: '', reason: ''}) {
      if (status !== '11' && this.details.installments && this.details.installments.length && !this.paymentInstalmentModeChoosed) {
        this.$bus.$emit('popup-choice-payment-instalment', {
          'amount': this.details.amount,
          'currency': this.details.currency,
          'installments': this.details.installments,
          'optionals': optionals,
          'requestedExecutionDate': this.details.requestedExecutionDate,
          'status': status
        })
        return
      } else if (status === '11' && this.details.installments && this.details.installments.length) {
        this.oneTimePayment = '1'
      }

      let today = moment().format('YYYY-MM-DD')
      if (
        moment(this.details.requestedExecutionDate).format(
          'YYYY-MM-DD'
        ) < today
      ) {
        this.$f7.alert('', this.$t('errors.invld_exec_dt'))
        return
      }
      let execDate =
        optionals.ImmPmtAc === 'true'
          ? today
          : moment(this.details.requestedExecutionDate).format(
              'YYYY-MM-DD'
            )
      let that = this
      let debtorBankAccountToSend = ''
      debtorBankAccountToSend = that.bankAccountSelectDebit
      let amount =  this.details.amount
      amount =
        parseFloat(amount) % 1 === 0 ? amount : parseFloat(amount).toFixed(2)
      let multiplePaymentsToSend = []
      let data = {
        idRequest: that.details.id,
        debtorName: this.details.debtorName,
        debtorIdentifier: this.details.debtorIdCompany,
        textStatus: status,
        amount: this.details.amountResponse ? this.details.amountResponse : this.details.amount,
        currency: this.details.currency,
        oneTimePayment: this.oneTimePayment
      }

      if (status === '6' && this.details.standard === '2') {
        data.reasonType = optionals.reasonType
        data.reason = optionals.reason
      }

      if (status === '9') {
        if (this.originalDate !== this.details.requestedExecutionDate) {
          data.executionDate = this.originalDate,
          data.acceptedExecutionDateTime = this.details.requestedExecutionDate
        }

        if (this.originalReason !== this.details.reason) {
          data.acceptedReason = this.details.reason
        }
      }

      if (status === '10' && this.details.standard === '2') {
        data.acceptedReason = this.details.reason
      }

      //change reason to code if RJCT
      if (status === '11') {
        if (optionals.reasonType === 'OTHER') {
          data.reasonType = 'Proprietary'
          data.reason = optionals.reason
        } else if (this.details.standard === '2') {
          data.reasonType = 'Code'
          data.reason = 'DS02'
          if(optionals.reason === undefined || optionals.reason === '' ) {
            data.additionalInformation = undefined
          } else {
            data.additionalInformation = optionals.reason
          }
        } else {
          data.reasonType = 'Code'
          data.reason = optionals.reasonType
        }
      }

      if (status === '21' && this.details.standard === '2') {
        data.reasonType = optionals.reasonType
        data.reason = optionals.reason
        data.acceptedExecutionDateTime = this.details.requestedExecutionDate
        if (!this.details.acceptedRemittanceInformation) {
          data.acceptedReason = this.details.reason
        } else {
          data.acceptedReason = this.details.acceptedRemittanceInformation
        }
      }

      if(status === '22' && this.details.standard === '2') {
        if (!this.details.acceptedRemittanceInformation) {
          data.acceptedReason = this.details.reason
        } else {
          data.acceptedReason = this.details.acceptedRemittanceInformation
          data.reasonType = undefined
          data.reason = undefined
        }
      }

      // add installments if necessary
      if (this.details.installments && this.details.installments.length) {
        data.installments = []
        this.details.installments.forEach((inst) => {
          data.installments.push({
            RequestedExecutionDate: inst.Date,
            Amount: inst.Amount,
            Currency: data.currency,
          })
        })
      }
      that.$engine.services.payments
        .answerToPayments(data)
        .then((response) => {
          if (response.status === 200) {
            if (that.payStatus === '1') {
              if (status === '21') {
                that.$f7.modal({
                  title: that.$t('common.status.rejected_request'),
                  text: '<span class="preloader"></span>'
                })
              } else {
                that.$f7.modal({
                  title: that.$t('common.status.accepted_request'),
                  text: '<span class="preloader"></span>'
                })
              }
              setTimeout(function () {
                that.$f7.closeModal()
                that.payStatus = '1'
                // appeler paiement
                if(that.details.standard === '1') {
                  that.pay()
                } else {
                  if (['21', '22'].includes(status)) {
                    that.seeDetails()
                  } else {
                    that.pay()
                  }
                }
              }, 2000)
            } else {
              switch (status) {
                case '6':
                  that.$f7.modal({
                    title: that.$t('common.status.revoked_request'),
                    text: '<span class="preloader"></span>',
                  })
                  break
                case '10':
                case '9':
                  // that.$f7.alert('Your payments will become effective on ' + execDate, 'Transaction Accepted')
                  that.$f7.modal({
                    title: that.$t('common.status.accepted_request'),
                    text: '<span class="preloader"></span>',
                  })
                  break
                case 'modify':
                  // that.$f7.alert('Your payments will become effective on ' + execDate, 'Transaction validated with modification')
                  that.$f7.modal({
                    title: that.$t('requestToPay.pymnts_effctv_on') + execDate,
                    text: '<span class="preloader"></span>',
                  })
                  break
                case '11':
                  // that.$f7.alert('', 'Transaction Revoked')
                  that.$f7.modal({
                    title: that.$t('common.trnsctn_rfsd'),
                    text: '<span class="preloader"></span>',
                  })
                  break
                case '21':
                  that.$f7.modal({
                    title: that.$t('common.status.rejected_request'),
                    text: '<span class="preloader"></span>',
                  })
                  break
                case '22':
                  that.$f7.modal({
                    title: that.$t('common.status.accepted_request'),
                    text: '<span class="preloader"></span>',
                  })
                  break
                default:
                  // that.$f7.alert('', 'Unknown Action')
                  that.$f7.modal({
                    title: this.$t('common.unknwn_actn'),
                    text: '<span class="preloader"></span>',
                  })
              }
              setTimeout(function () {
                that.$f7.closeModal()
                that.$engine.settings.set({ pendingChange: true })
                that.$engine.settings.set({ inboxNormalCount: null })
                that.seeDetails()
              }, 2000)
            }
          }
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    },
    cancelRequestToPay (endToEndId, reason = '', reasonType = '') {
      if (reasonType === '' || (reasonType === '' && this.isHRTP)) {
        this.$bus.$emit('popup-choice-payment-cancel', {
          endToEndId: endToEndId
        })
      } else {
        const that = this
        that.$engine.services.payments
          .paymentsCancel(
            that.idRequest,
            reason,
            reasonType
          )
          .then((response) => {
            if (response.status === 200) {
              that.$f7.modal({
                title: that.$t('common.status.aborted_request'),
                text: '<span class="preloader"></span>',
              })
              setTimeout(function () {
                that.$f7.closeModal()
                that.seeDetails()
              }, 2000)
            }
          })
          .catch((error) => {
            that.$f7.alert(that.$i18n.t('errors.cncl_failed'), that.$i18n.t('errors.AlreadyExpiredRTP'))
            // errorMessageAlert(error, that)
          })
      }
    },
    changeInstallementDates(val, index) {
      let tempDate = _.cloneDeep(val)
      let tempInstallements = _.cloneDeep(this.details.installments)
      tempInstallements[index].Date = formatDateTime(tempDate)
      this.details.installments = tempInstallements
    },
    changeDebtorsAmount(changingNb = false){
      if (this.details.installments.length){
        this.details.amount = parseFloat(this.details.amount).toFixed(2).toString()
        if (this.details.amount === '' || parseFloat(this.details.amount) <= 0){
          for(let index = 0; index < this.details.installments.length; index++){
            this.details.installments[index].Amount = ''
          }
        } else {
          const installmentAmount = Math.floor(this.details.amount * 100.0 / this.details.installments.length) / 100
          let installmentAmountTotal = 0
          let diff = -1
          let nbDiff = 0
          while (diff < 0) {
            installmentAmountTotal = 0
            for (let index = 0 ; index < this.details.installments.length; index++) {
              let newAmount = ''
              if(index >= this.details.installments.length + 1 - nbDiff) {
                diff = parseFloat(this.details.amount) - installmentAmountTotal
                newAmount = diff.toFixed(2).toString()
              } else if (this.details.installments[index].Amount === '' && parseFloat(this.details.amount) - installmentAmountTotal > 0 && changingNb) {
                newAmount = installmentAmount.toFixed(2).toString()
              } else {
                if (changingNb) {
                  newAmount = installmentAmount.toFixed(2).toString()
                } else if (this.details.installments[index].Amount === '') {
                  newAmount = '0.00'
                } else {
                  newAmount = parseFloat(this.details.installments[index].Amount).toFixed(2).toString()
                }
              }

              if (newAmount === '0.00') {
                if (this.details.installments[index].Amount !== '' && this.details.installments[index].Amount !== '0.00') {
                  this.details.installments[index].Amount = ''
                }
              } else {
                if (this.details.installments[index].Amount !== newAmount){
                  this.details.installments[index].Amount = newAmount
                }
              }

              if (this.details.installments[index].Amount !== '') {
                if (parseFloat(this.details.installments[index].Amount) > 0) {
                  installmentAmountTotal += parseFloat(this.details.installments[index].Amount)
                }
              }
              nbDiff++
            }
          }
        }
      }
    },
    changeDebtorsDate () {
      this.details.installments.forEach((installment, indexInstallment) => {
        if (this.details.requestedExecutionDate < formatDateTime(installment.Date)) {
          this.details.requestedExecutionDate = installment.Date
        }
      })
      this.details.installments.sort(this.orderInstallmentByDateString)
      // console.log('this.installments', this.installments)
      this.installmentRefresh = !this.installmentRefresh
    },
    checkForWritePermissions (sucess, error) {
      /* eslint-disable no-undef */
      if (this.$f7.device.os === 'android') {
        cordova.plugins.diagnostic.requestRuntimePermission(
          function (status) {
            switch (status) {
              case cordova.plugins.diagnostic.permissionStatus.GRANTED:
                // console.log('Permission granted')
                sucess()
                break
              case cordova.plugins.diagnostic.permissionStatus.DENIED:
                // console.log('Permission denied')
                error()
                break
              case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
                //console.log('Permission permanently denied')
                error()
                break
            }
          },
          function (error) {
            console.error('The following error occurred: ' + error)
          },
          cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
        )
      } else if (this.$f7.device.os === 'ios') {
        sucess()
      }
      /* eslint-enable no-undef */
    },
    concatenatedDateAmountText (text) {
      return text + ' : ' + this.details.amount
    },
    concatenatedDateAskText (text) {
      return text + ' : ' + moment(this.details.requestedExecutionDate).format('DD/MM/YYYY HH:mm:ss')
    },
    concatenatedDateReasonText (text) {
      return text + ' : ' + this.details.reason
    },
    confirmNegotiation () {
      let that = this
      if (that.bankAccountSelectDebit.length === 0) {
        this.$f7.alert('', 'Bank account missing')
        return
      }
      if (
        parseFloat(this.$engine.settings.get(1).validationThreshold) >
        parseFloat(this.details.amount)
      ) {
        let status = '2'
        if (
          that.$settings.clickedMessage.amount ===
            that.details.pmtNegot.amountDebtor &&
          that.$settings.clickedMessage.requestedExecutionDate ===
            that.details.pmtNegot.debtorPaymentsDate
        ) {
          status = '1'
        }
        let amount = parseFloat(that.details.pmtNegot.amountDebtor)
        amount =
          parseFloat(amount) % 1 === 0 ? amount : parseFloat(amount).toFixed(2)
        let debtorBankAccountToSend = that.bankAccountSelectDebit
        // debtorBankAccountToSend = that.bankAccountSelectDebit
        that.$engine.services.payments
          .answerToPayments(
            that.$settings.clickedMessage.id,
            status,
            amount,
            that.details.pmtNegot.debtorPaymentsDate,
            '',
            debtorBankAccountToSend,
            that.$engine.settings.get(1).isToGenerateXML,
            that.details.pmtNegot.immediatePayments === 'true',
            that.details.pmtNegot.multiPayments
          )
          .then((response) => {
            that.seeDetails()
          })
          .catch((error) => {
            errorMessageAlert(error, that)
          })
      } else {
        this.$f7.modal({
          title: this.$t('common.cnfrm_trnsctn'),
          text: this.$t('common.comment_size'),
          afterText:
            '<div class="item-input textarea-modal-rtp"><textarea class="confirmNegotiation commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {},
            },
            {
              text: 'Ok',
              onClick: function () {
                let status = '2'
                if (
                  that.$settings.clickedMessage.amt ===
                    that.details.pmtNegot.amountDebtor &&
                  that.$settings.clickedMessage.requestedExecutionDate ===
                    that.details.pmtNegot.debtorPaymentsDate
                ) {
                  status = '1'
                }
                let amount = parseFloat(that.details.pmtNegot.amountDebtor)
                amount =
                  parseFloat(amount) % 1 === 0
                    ? amount
                    : parseFloat(amount).toFixed(2)
                let debtorBankAccountToSend = ''
                // if (that.details.dbBkAcct === '') {
                debtorBankAccountToSend = that.bankAccountSelectDebit
                // }
                that.$engine.services.payments
                  .answerToPayments(
                    that.$settings.clickedMessage.id,
                    status,
                    amount,
                    that.details.pmtNegot.debtorPaymentsDate,
                    that.Dom7('.confirmNegotiation').val(),
                    debtorBankAccountToSend,
                    that.$engine.settings.get(1).isToGenerateXML,
                    that.details.pmtNegot.immediatePayments === 'true',
                    that.details.pmtNegot.multiPayments
                  )
                  .then((response) => {
                    that.seeDetails()
                  })
                  .catch((error) => {
                    errorMessageAlert(error, that)
                  })
              },
            },
          ],
        })
      }
    },
    copyToClipboard (value) {
      const copyText = document.getElementById('inputUri')
      navigator.clipboard.writeText(copyText.innerHTML)
      const tooltip = document.getElementById('copyUri')
      const tooltipOrgnlText = tooltip.innerHTML
      tooltip.innerHTML = 'Copié !'
    },
    copyToClipboardReset (value) {
      const tooltip = document.getElementById('copyUri')
      tooltip.innerHTML = this.$t('common.copy_to_clipboard')
    },
    detailsAutoRefresh () {
      // console.log('detailsAutoRefresh')
      let refreshTimer = undefined
      if (this.nbRefresh >= this.refreshTimers.length) {
        refreshTimer = this.refreshTimers[this.refreshTimers.length - 1]
      } else {
        refreshTimer = this.refreshTimers[this.nbRefresh]
      }
      if (this.idRefresh) {
        clearTimeout(this.idRefresh)
        this.idRefresh = undefined
      }
      let that = this
      this.idRefresh = setTimeout(() => {
        // console.log('setTimeout triggered')
        that.seeDetails(true)
        that.nbRefresh++
      }, refreshTimer * 1000)
    },
    download (id) {
      /* eslint-disable no-undef */
      const that = this
      this.$f7.showPreloader('Downloading File')
      this.$engine.services.payments
        .getAttachmentDetail(id)
        .then((response) => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({
            Attachment: {
              data: response.data.documentData,
              name: response.data.documentName,
              mimeType: response.data.documentData
                .split('')[0]
                .replace(/^data:/, ''),
              id: id,
            },
          })
          that.writeToFile(
            response.data.documentName,
            response.data.documentData,
            response.data.documentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType) {
              that.$f7.alert(
                filePath.split('/')[filePath.split('/').length - 1],
                'Following file successfully saved.'
              )
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        })
        .catch((error) => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      /* eslint-enable no-undef */
    },
    formateInstalmentDate (dt) {
      return moment(dt).format('YYYY-MM-DDTHH:mm:ss')
    },
    formatLettrage: formatLettrage,
    getBankName (iban) {
      const code = iban.substring(4, 9)
      const bankName = bankDatas.Banks.find((e) => e.code === code).name
      return bankName
    },
    getCancelCodeLabel (code) {
      return getCancelLabel(code)
    },
    getCurrencyIcon (ccy) {
      switch (ccy) {
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'GBP':
          return '£'
        case 'JPY':
          return '¥'
        case 'RUB':
          return '₽'
        case 'HUF':
          return 'Ft'
        default:
          return ccy
      }
    },
    getHistoryIcon (status) {
      return statusIcon(status)
    },
    getHistoryLabel (status) {
      let status_label
      if (status === '1' && this.details.direction === '0') {
        status_label = this.$i18n.t('common.status.received_request')
      } else if (status === '1' && this.details.direction === '1') {
        status_label = this.$i18n.t('common.status.issued_request')
      } else {
        status_label = this.$i18n.t('common.status.rtp.' + status)
        if (status_label === ('common.status.rtp.' + status)) {
          status_label = this.$i18n.t('common.status.unknown')
        }
      }
      return status_label
    },
    getStatusIcon (status, negotStatus) {
      return statusIcon(status, negotStatus)
    },
    getStatusLabel (status) {
      let status_label
      if (status === '1' && this.details.direction === '0') {
        status_label = this.$i18n.t('common.status.received_request')
      } else if (status === '1' && this.details.direction === '1') {
        status_label = this.$i18n.t('common.status.issued_request')
      } else {
        status_label = this.$i18n.t('common.status.rtp.' + status)
        if (status_label === ('common.status.rtp.' + status)) {
          status_label = this.$i18n.t('common.status.unknown')
        }
      }
      return status_label
    },
    getStatusReason (status) {
      let reason = undefined
      switch (status) {
        case '6':
          reason = this.getRefusReason
          return reason ? reason : this.$i18n.t('common.cancel_reason.OTHR')
        case '11':
          reason = this.isHRTP ? this.details.additionalInformation : this.getRefusReason
          return reason ? reason : this.$i18n.t('common.cancel_reason.OTHR')
        case '13':
        case '14':
          reason = this.getCancelReason
          return reason && !this.isHRTP ? reason : this.$i18n.t('common.cancel_reason.OTHR')
        default:
          return reason
      }
    },
    hasPastExecutionDateInstalment (installment) {
      return ['9','10'].includes(this.details.status) && this.details.direction === '0' && moment(installment.Date).isBefore(moment())
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, true)
    },
    hideIban (iban) {
      return formatIbanHiddenEnd(iban)
    },
    openDoc (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      let that = this
      let win = window
      this.$f7.showPreloader(this.$i18n.t('loading.loading_file'))
      this.$engine.services.payments
        .getAttachmentDetail(id)
        .then((response) => {
          this.$engine.settings.set({
            Attachment: {
              data: response.data.documentData,
              name: response.data.documentName,
              mimeType: response.data.documentData
                .split('')[0]
                .replace(/^data:/, ''),
              id: id,
            },
          })
          if (
            that.$f7.device.os === 'android' ||
            that.$f7.device.os === 'ios'
          ) {
            that.$f7.hidePreloader()
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else {
            // browser
            let blob = b64toBlob(
              response.data.documentData.split(',')[1],
              response.data.documentData.split('')[0].replace(/^data:/, '')
            )
            let url = window.URL.createObjectURL(blob)
            that.$f7.hidePreloader()
            win.open(url)
          }
        })
        .catch((error) => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
    },
    orderInstallmentByDateString(a, b) {
      // Comparer les propriétés data des objets
      if (a.Date < b.Date) {
        return -1
      } else if (a.Date > b.Date) {
        return 1
      } else {
        return 0
      }
    },
    pay () {
      if (!this.debtorBankAccount && this.payStatus === '0') {
        this.$bus.$emit('popup-choice-bank-account', {})
        return
      }
      const that = this
      this.$engine.services.payments.payRTP(this.idRequest, this.debtorBankAccount)
        .then((response) => {
          if (response.status === 200) {
            that.$f7.modal({
              title: that.$t('requestToPay.initiate_pay'),
              text: '<span class="preloader"></span>',
            })
            setTimeout(function () {
              that.$f7.closeModal()
              that.seeDetails()
            }, 2000)
          }
        })
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(
          entry.nativeURL.replace(/%20/g, ' '),
          fileType,
          {
            error: function (e) {
              // TODO : screen user stuff
            },
            success: function (s) {
              // TODO : screen user stuff
            },
          }
        )
      })
    },
    refuseNegotiation () {
      let that = this
      if (
        parseFloat(this.$engine.settings.get(1).validationThreshold) >
        parseFloat(this.details.amount)
      ) {
        that.$engine.services.payments
          .negotiatePayments(
            that.$settings.clickedMessage.id,
            'negotResp',
            'KO',
            Number(that.$settings.clickedMessage.amount),
            false,
            that.$settings.clickedMessage.requestedExecutionDate,
            ''
          )
          .then((response) => {
            if (response.status === 200) {
              that.$f7.alert('', 'Negotiation Refused', function () {
                that.$f7.closeModal()
                that.seeDetails()
              })
            }
          })
          .catch((error) => {
            errorMessageAlert(error, that)
          })
      } else {
        that.$f7.modal({
          title: 'Refuse Negotiation',
          text: that.$t('common.comment_size'),
          afterText:
            '<div class="item-input textarea-modal-rtp"><textarea class="refuseNegotiation commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {},
            },
            {
              text: 'Ok',
              onClick: function () {
                that.$engine.services.payments
                  .negotiatePayments(
                    that.$settings.clickedMessage.id,
                    'negotResp',
                    'KO',
                    Number(that.$settings.clickedMessage.amount),
                    false,
                    that.$settings.clickedMessage.requestedExecutionDate,
                    that.Dom7('.refuseNegotiation').val()
                  )
                  .then((response) => {
                    if (response.status === 200) {
                      that.$f7.alert('', 'Negotiation Refused', function () {
                        that.$f7.closeModal()
                        that.seeDetails()
                      })
                    }
                  })
                  .catch((error) => {
                    errorMessageAlert(error, that)
                  })
              }
            }
          ]
        })
      }
    },
    remindReceiver (id) {
      let that = this
      that.$engine.services.payments
        .paymentsRemind(id)
        .then((response) => {
          if (response.status === 200) {
            that.$f7.modal({
              title: 'Receiver reminded',
              text: '<span class="preloader"></span>',
            })
            setTimeout(function () {
              that.$f7.closeModal()
              that.seeDetails()
            }, 2000)
          }
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(
        directory,
        function (directoryEntry) {
          directoryEntryReference = directoryEntry
          directoryEntry.getFile(
            fileName,
            { create: true, exclusive: true },
            function (fileEntry) {
              fileEntry.createWriter(
                function (fileWriter) {
                  fileWriter.onwriteend = function (e) {
                    success(e.target.localURL, fileType, fileName)
                  }
                  fileWriter.onerror = function (e) {
                    error()
                  }
                  let blob = b64toBlob(
                    data.replace(/^[^,]*,/, ''),
                    fileType
                  )
                  fileWriter.write(blob)
                },
                (e, file) => {}
              )
            },
            (e, file) => {
              navigator.notification.confirm(
                'This file already exists do you want to override it ? (' +
                  fileName +
                  ')',
                function (index) {
                  /* console.log(
                    'Do you want to override the following file: ' +
                      fileName +
                      ' (' +
                      index +
                      ')'
                  ) */
                  switch (index) {
                    case 1: // No
                      // console.log('No. Returning to idle state.')
                      break
                    case 2: // Yes -> overrides  the file
                      // console.log('Yes. Overriding file.')
                      directoryEntryReference.getFile(
                        fileName,
                        { create: true, exclusive: false },
                        function (fileEntry) {
                          fileEntry.createWriter(
                            function (fileWriter) {
                              fileWriter.onwriteend = function (e) {
                                success(e.target.localURL, fileType, fileName)
                              }
                              fileWriter.onerror = function (e) {
                                error()
                              }
                              let blob = b64toBlob(
                                data.replace(/^[^,]*,/, ''),
                                fileType
                              )
                              fileWriter.write(blob)
                            },
                            (e, file) => {}
                          )
                        },
                        (e, file) => {}
                      )
                      break
                  }
                },
                'Information',
                ['No', 'Yes']
              )
            }
          )
        },
        (e, file) => {
          // error resolveLocalFileSystemURL
        }
      )
      /* eslint-enable no-undef */
    },
    seeDetails (autoRefresh = false) {
      // console.log('seeDetails')
      let that = this
      if (!autoRefresh) {
        this.activateSpinner = true
      }
      this.idRequest = this.$engine.services.payments.idRequest
      this.$engine.services.payments.updateStreamRTP(2, 1000, 1, {idRequest: this.idRequest})
      .then(resp => {
        if (that._isDestroyed) {
          return
        }
        // if auto refresh is running and the call is for autoRefresh, show spinner
        if (resp.data.payments[0].status !== that.details.status && autoRefresh) {
          that.activateSpinner = true
          // if the new status is a definitive status, stop the auto refresh
          if (that.idRefresh && !['1','5','13','15'].includes(that.details.status)) {
            clearTimeout(that.idRefresh)
          }
        }
        // check status to keep going on refresh
        if (['1','5','13','15'].includes(resp.data.payments[0].status)) {
          that.detailsAutoRefresh()
        }
        // if status didnt change, do not refresh details
        if (resp.data.payments[0].status === that.details.status && autoRefresh) {
          return
        }
        that.details = resp.data.payments[0]
        // console.log('details', this.details)
        if (that.details && that.details.format && that.details.format.request) {
          that.fileFormat = that.details.format.request
        }
        that.standard = that.details.standard
        that.originalInstallements = that.details.installments
        that.originalDate = that.details.requestedExecutionDate
        that.originalAmount = that.details.amount
        that.originalReason = that.details.reason
        that.details.reason = that.details.reason === '' ? '-' : that.details.reason
        that.activateSpinner = false
        if (that.details.standard === '2') {
          // for HRTP, bank account is defined by the creditor
          that.debtorBankAccount = that.details.debtorBankAccount
        }
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
      return
      if (message.id) {
        message.executionDateResponse = message.executionDateResponse.substring(
          0,
          10
        )
      }
      this.$engine.settings.set({
        clickedMessage: message,
      })
      this.$engine.settings.set({
        msgFromInbox: isReceived,
      })

      if (message.isRead !== '1') {
        message.isRead = '1'
        this.$engine.services.payments
          .setPaymentsRead({
            id: message.id,
            isRead: 1,
          })
          .then((response) => {})
          .catch((error) => {
            errorMessageAlert(error, that)
          })
      }
      this.$forceCompute('details')
      this.$forceCompute('oldAmount')
      this.$forceCompute('oldDate')
    },
    seeXml (data, service, action) {
      let that = this
      const id = data.id
      const type = data.type
      let xmlDetails = {}
      this.$engine.services.payments
        .getXml(service, type, id)
        .then((resp) => {
          if (resp.data) {
            xmlDetails = resp.data
            xmlDetails.type = type
            if (action === 'see') {
              that.$bus.emit('popup-xml-details', xmlDetails)
            } else {
              //download file
              const fileName =
                moment().format('YYYYMMDD_hhmmss_') + type + '.xml'
              downloadFileWithDefinedHeaders(that, fileName, resp.data.data)
              that.$f7.alert('', that.$i18n.t('common.xml_downloaded'))
            }
          }
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    },
    showAcceptModifyAmount () {
      return (
        this.details.direction === '0' &&
        this.details.acceptModifyAmount === '1' &&
        this.details.status === '5'
      )
    },
    showAcceptModifyAmountCreditor () {
      return (
        this.details.direction === '1' &&
        this.details.acceptModifyAmount === '1' &&
        this.details.status === '5'
      )
    },
    showAcceptModifyAmountValided () {
      return (
        this.details.amountResponse &&
        this.details.amountResponse !== this.details.amount
      )
    },
    showAcceptModifyDate () {
      return (
        this.details.direction === '0' &&
        this.details.acceptModifyExecutionDate === '1' &&
        this.details.status === '5'
      )
    },
    showAcceptModifyDateCreditor () {
      return (
        this.details.direction === '1' &&
        this.details.acceptModifyExecutionDate === '1' &&
        this.details.status === '5'
      )
    },
    showAcceptModifyDateValided () {
      return (
        this.details.acceptedRequestedExecutionDatetime &&
        this.details.acceptedRequestedExecutionDatetime !== this.details.requestedExecutionDate
      )
    },
    showAcceptModifyReason () {
      return (
        this.details.direction === '0' &&
        this.details.acceptModifyRemittanceInformation === '1' &&
        this.details.status === '5'
      )
    },
    showAcceptModifyReasonCreditor () {
      return (
        this.details.direction === '1' &&
        this.details.acceptModifyRemittanceInformation === '1' &&
        this.details.status === '5'
      )
    },
    showAcceptModifyReasonValidated () {
      return (
        this.details.acceptedRemittanceInformation &&
        this.details.acceptedRemittanceInformation !== this.details.reason
      )
    },
    showButtonAccept () {
      return (
        this.details.direction === '0' &&
        this.details.status === '5' &&
        this.details.standard !== '2'
      )
    },
    showButtonAcceptAndPay () {
      if(this.$engine.rights.rightIs('paymentpay_ajouter', true)) {
        return (
          this.details.direction === '0' &&
          this.details.status === '5' &&
          this.details.creditNoteAmount === undefined
        )
      }
    },
    showButtonAcceptNegotiation () {
      return (
        this.waitingForAnswerRTP(this.details.status) &&
        this.details.negotStatus === '10' &&
        this.details.pymtModAcpt === 'true'
      )
    },
    showButtonCancel () {
      return (
        (this.details.status === status.WAITING ||
          this.details.status === status.RECEIVED) &&
        !this.isDebtorAnon
      )
    },
    showButtonNegotiate () {
      return (
        this.details.acceptMultipleInstalments === '1' &&
        (this.waitingForAnswerRTP(this.details.status) ||
          this.details.status === status.MODIFIED) &&
        false
      )
    },
    showButtonPay () {
      if(this.$engine.rights.rightIs('paymentpay_ajouter', true)) {
        return (this.details.direction === '0' &&
          ['9','10'].includes(this.details.status) &&
          this.details.pay !== 'none' &&
          this.details.creditNoteAmount === undefined &&
          !this.$engine.user.isOtp &&
          this.details.standard !== '2'
        )
      }
    },
    showButtonPaymentValidate () {
      let statusWasThere = false //DRO 25/08/202 variable vraie si nous avons eu le statut correspondant dans l'historique, fausse si le contraire (utilisée lorsqu'une HRTP à une annulation rejetée)
      this.details.history.forEach( record => {
        if (record.status === '20') {
          statusWasThere = true
        }
        if (['21', '22'].includes(record.status)) {
          statusWasThere = false
        }
      })
      if(this.$engine.rights.rightIs('paymentpay_ajouter', true)) {
        return ((this.details.direction === '0' &&
          (this.details.status === '20' || statusWasThere === true)  &&
          this.details.pay !== 'none' &&
          this.details.creditNoteAmount === undefined &&
          this.details.standard === '2')
        )
      }
    },
    showButtonRefuse () {
      return (
        this.details.direction === '0' &&
        this.details.status === '5'
      )
    },
    showInstantPayment (iban) {
      const code = iban.substring(4, 9)
      if (!bankDatas.Banks.find((e) => e.code === code)) {
        return false
      }
      const instantPayment = bankDatas.Banks.find((e) => e.code === code).sctinst
      return instantPayment
    },
    showNegotiation () {
      return (
        (this.waitingForAnswerRTP(this.details.status) &&
          this.details.negotStatus === '10') ||
        (this.waitingForAnswerRTP(this.details.status) &&
          this.details.negotStatus === '11')
      )
    },
    showOtherDebtors () {
      return this.details.IdGroup
    },
    showPain001View (record) {
      return (
        record.status === status.ORDER_GENERATED ||
        record.status === status.INST_ORDER_GENERATED
      )
    },
    showPaymentAxepta () {
      this.payStatus = '1'
      /* Remplacer reason par la ref de la facture */
      const amount =
        this.$settings.clickedMessage.amount !== ''
          ? this.$settings.clickedMessage.amount
          : this.details.amount
      this.$bus.$emit('popup-payment-axepta', {
        amount: amount,
        currency: this.details.currency,
        description: this.details.reason,
        ref: this.details.reason,
        selectScreen: true,
        transId: this.details.endToEndId,
      })
    },
    transactionAccepted () {
      let that = this
      if (
        this.details.acceptModifyAmount !== '0' &&
        (this.details.amount === '' || parseInt(this.details.amount) <= 0)
      ) {
        this.$f7.alert('', this.$t('errors.invld_amnt'))
        return
      }

      if (
        this.details.acceptModifyReason !== '0' &&
        (this.details.reason === '')
      ) {
        this.$f7.alert('', this.$t('errors.invld_reason'))
        return
      }

      let TxStatus = '10'

      // boucle sur tous les instalments
      // pour chaque instalment, check si changement de date ou de montant par rapport à l'original
      // si oui, TxtStatus = ACWC
      // si date du dernier instalment a changé, changer aussi le requestedExecutionDate
      let installmentHasError = false
      const today = moment().format('YYYY-MM-DD')

      this.details.installments.forEach((elem, index) => {
        if((elem.Amount === '' || parseInt(elem.Amount) <= 0) && !installmentHasError){
          this.$f7.alert('', this.$t('errors.installment_sum_error'))
          installmentHasError = true
        }
        if((elem.Date === '' || moment(elem.Date).format('YYYY-MM-DD') < today) && !installmentHasError){
          this.$f7.alert('', this.$t('errors.installment_date'))
          installmentHasError = true
        }
        if(elem.Amount !== this.originalInstallements[index].Amount || elem.Date !== this.originalInstallements[index].Date) {
          that.hasInstallmentsChanged = true
          if (that.details.installments.length === (index + 1)) { // c'est le dernier
            if(elem.Date !== this.originalInstallements[index].Date){
              that.details.requestedExecutionDate = elem.Date
            }
          }
        }
      })

      if (installmentHasError) {
        return
      }


      if (
        this.details.acceptModifyExecutionDate !== '0' &&
        (this.details.requestedExecutionDate === '' ||
          moment(this.details.requestedExecutionDate).format('YYYY-MM-DD') <
            moment().format('YYYY-MM-DD'))
      ) {
        this.$f7.alert('', this.$t('errors.invld_dt'))
        return
      }


      if (this.details.requestedExecutionDate && this.details.amount && this.details.reason) {
        if(this.originalDate !== this.details.requestedExecutionDate || this.originalAmount !== this.details.amount || this.originalReason !== this.details.reason || this.hasInstallmentsChanged) {
          TxStatus = '9'
        }
      }


      if (
        parseFloat(this.$engine.settings.get(1).validationThreshold) >
        parseFloat(this.details.amount)
      ) {
        this.action = 'accept'
        this.ImmPmtAccepted = 'true'
        this.answerToPayments(TxStatus, {
          comment: '',
          isToGenerateXML: this.$engine.settings.get(1).isToGenerateXML
        })
      } else {
        this.$f7.modal({
          title: this.$t('common.cnfrm_trnsctn'),
          text: this.$t('common.comment_size'),
          buttons: [
            {
              text: 'Cancel',
              onClick () {},
            },
            {
              text: 'Ok',
              onClick ($event) {
                that.action = 'accept'
                that.ImmPmtAccepted = 'true'
                that.answerToPayments(TxStatus, {
                  comment: that.Dom7('.acceptComment').val(),
                  isToGenerateXML: that.$engine.settings.get(1).isToGenerateXML,
                })
              }
            }
          ]
        })
      }
    },
    transactionAcceptedAndPay () {
      this.payStatus = '1'
      if (!this.debtorBankAccount) {
        this.$bus.$emit('popup-choice-bank-account', {})
        return
      }
      /* if (!this.debtorBankAccount) {
        this.$f7.alert('', this.$t('errors.bnk_act_mssng'))
        return
      } */
      this.transactionAccepted()
    },
    transactionRefused () {
      this.$bus.$emit('popup-choice-payment-refuse', this.details.standard)
    },
    viewXML () {
      let that = this
      this.$f7.showPreloader(that.$i18n.t('common.opnng_fl'))
      // let userId = that.$engine.user.get().id
      // this.$engine.services.getEnvelope(idMessage, typeMessage, userId)
      this.$engine.services
        .getXMLDetail('payment', 'pain001', that.details.id)
        .then((response) => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({
            type: {
              data: response.data,
            },
          })
          /* TLV 22/09/2020
           * Lignes ci-dessous a decommenter quand on testera le telechargement de
           * fichiers sur mobile */
          /* if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              typeMessage + '_' + idMessage + '.xml',
              response.data.data,
              response.data.data.split('')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else { */ // browser
          /* let blob = base64url.decode(response.data['envelopes'][0].message)
          const linkSource = 'data:text/csvcharset:utf-8,' + blob */
          let blob = b64toBlob(response.data.data.split(',')[1], 'text/xml')
          let linkSource = window.URL.createObjectURL(blob)
          let fileLink = document.createElement('a')
          fileLink.href = linkSource
          let today = moment().format()
          fileLink.setAttribute('download', 'Technical_View' + today + '.xml') // or any other extension
          fileLink.click()
          // }
        })
        .catch((error) => {
          that.$f7.hidePreloader()
          console.log(error)
        })
    },
    waitingForAnswerRTP (requestStatus) {
      return (
        requestStatus === status.RECEIVED || requestStatus === status.WAITING
      )
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (this.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (this.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        this.saveFileToDirectory(
          fileName,
          data,
          fileType,
          directory,
          success,
          error
        )
      } else {
        // directory = cordova.file.externalRootDirectory
        if (this.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (this.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          this.checkForWritePermissions(
            function () {
              try {
                window.resolveLocalFileSystemURL(
                  directory,
                  function (directoryEntry) {
                    directoryEntry.getDirectory(
                      'Download',
                      { create: true },
                      function (downloadDir, _data) {
                        that.saveFileToDirectory(
                          fileName,
                          data,
                          fileType,
                          downloadDir.nativeURL,
                          function (filePath, fileType) {
                            console.log('sucess saving file: ', filePath)
                          },
                          function (error, _data) {
                            console.error('error on saving file' + error.code)
                            alert('Unable to save file: ' + error.code)
                          }
                        )
                      },
                      function (error, _data) {
                        console.error(
                          'error on accessing download directory' + error.code
                        )
                        alert(
                          'Unable to get/create download directory: ' +
                            error.code
                        )
                      }
                    )
                  },
                  (e, file) => {
                    // error resolveLocalFileSystemURL
                  }
                )
              } catch (error) {
                // get dir
                console.error(error)
              }
            },
            function () {
              alert(
                'App needs access to the phone\'s file storage in order to save files.'
              )
            }
          )
        } catch (error) {
          // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    }
  }
}
</script>
